// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___ih9zW","root__wrapper":"style-module__root__wrapper___enjh1"};
    if(module.hot) {
      // 1697460457554
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  